import { from } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { GET_BROADCAST } from 'actions/Types';
import { BROADCAST_JOIN_SYNC_SERVER_TIME } from 'store/eventConstants';

const BROADCAST_PREFIX = 'broadcast';
const BROADCAST_DIRECTOR_PREFIX = 'broadcastDirector';

/**
 * Manages state of broadcast socket channel subscriptions
 */
const broadcastSocketMiddleware = socket => () => next => async action => {
  const targetedActions = [`${GET_BROADCAST}_SUCCESS`];

  from([action])
    .pipe(
      filter($action => targetedActions.includes($action.type)),
      take(1)
    )
    .subscribe($action => {
      const {
        payload: { _id: broadcastId, team, event }
      } = $action;

      if (broadcastId && team && event) {
        const params = {
          teamId: team,
          eventId: event,
          broadcastId
        };

        socket.subscribe(`${BROADCAST_PREFIX}.${broadcastId}`);
        socket.subscribe(`${BROADCAST_DIRECTOR_PREFIX}.${broadcastId}`, params);
        /** We also want to listen to events that this broadcast belong to */
        socket.subscribe(`event.${event}`, params);
        /**
         * This should happen only once, and only after the socket.subscribe calls happen
         */
        socket.emit(BROADCAST_JOIN_SYNC_SERVER_TIME, { broadcastId });
      }
    });

  return next(action);
};

export default broadcastSocketMiddleware;
